/**
 * Guard-компонент для защищённых маршрутов.
 * Обновлено: 2026-02-25 — добавлен проп requireSubscribe для отключения проверки подписки на отдельных маршрутах.
 * Управляет доступом по факту логина, правам и (по умолчанию) активной подписке.
 */

import {ReactElement} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../use-auth';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {useSettings} from '@common/core/settings/use-settings';

interface Props {
  children?: ReactElement;
  permission?: string;
  requireLogin?: boolean;
  // Если false — маршрут не требует активной подписки, даже при включённом биллинге
  requireSubscribe?: boolean;
}
export function AuthRoute({
  children,
  permission,
  requireLogin = true,
  requireSubscribe = true,
}: Props) {
  const {isLoggedIn, hasPermission, isSubscribed} = useAuth();
  const {billing} = useSettings();

  if (
    (requireLogin && !isLoggedIn) ||
    (permission && !hasPermission(permission))
  ) {
    if (isLoggedIn) {
      return billing.enable && !isSubscribed && requireSubscribe
        ? // Пользователь залогинен, биллинг включён, подписки нет и маршрут её требует — отправляем на /pricing
          // (поведение для всех платных разделов по умолчанию)
          <Navigate to="/pricing" replace />
        : // В остальных случаях показываем 404, если нет нужных прав/условий
          <NotFoundPage />;
    }
    return <Navigate to="/login" replace />;
  }
  return children || <Outlet />;
}
